/* 🤖 this file was generated by svg-to-ts*/
export const iconStarWhite = {
  name: 'star_empty',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 11.513l2.767 1.674a.665.665 0 00.993-.72l-.733-3.147 2.446-2.12a.665.665 0 00-.38-1.167l-3.22-.273-1.26-2.973a.667.667 0 00-1.226 0l-1.26 2.966-3.22.274a.665.665 0 00-.38 1.166l2.446 2.12-.733 3.147a.665.665 0 00.993.72L8 11.513z" fill-opacity=".6"/></svg>`,
}
